var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tiktok"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 18.4462C9.81371 18.4462 12.5 15.7599 12.5 12.4462V5.64347C13.3825 6.15398 14.4071 6.44617 15.5 6.44617H16.5V3.44617H15.5C13.8431 3.44617 12.5 2.10302 12.5 0.446167H9.5V12.4462C9.5 14.103 8.15685 15.4462 6.5 15.4462C4.84315 15.4462 3.5 14.103 3.5 12.4462C3.5 10.7893 4.84315 9.44617 6.5 9.44617V6.44617C3.18629 6.44617 0.5 9.13246 0.5 12.4462C0.5 15.7599 3.18629 18.4462 6.5 18.4462Z",
    fill: "#28303F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.306ab383da930b7a8fb023eb155f2553.svg";
export { ForwardRef as ReactComponent };